import { render, staticRenderFns } from "./spzx.vue?vue&type=template&id=211bae58&scoped=true"
import script from "./spzx.vue?vue&type=script&lang=js"
export * from "./spzx.vue?vue&type=script&lang=js"
import style0 from "./spzx.vue?vue&type=style&index=0&id=211bae58&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "211bae58",
  null
  
)

export default component.exports